import { useCallback, useEffect, useState } from 'react';

import { AuthService } from '../services/AuthService';

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoadingLogin, setIsLoadingLogin] = useState(false);
  const [user, setUser] = useState<{ phone: string; name?: string; email?: string } | null>(null);
  const [error, setError] = useState('');

  const login = useCallback(async (phoneNumber: string) => {
    setIsLoadingLogin(true);
    setError('');

    try {
      await AuthService.login(phoneNumber);
      setIsAuthenticated(true);

      const auth = AuthService.getStoredAuth();
      if (auth) {
        setUser({
          phone: auth.phone,
          name: auth.user?.name,
          email: auth.user?.email,
        });
      }
    } catch (error_) {
      setError(error_ instanceof Error ? error_.message : 'Login failed');
    } finally {
      setIsLoadingLogin(false);
    }
  }, []);

  const logout = useCallback(async () => {
    await AuthService.logoutAsync();
    setIsAuthenticated(false);
    setUser(null);
    setError('');
  }, []);

  useEffect(() => {
    const handleUnauthorized = () => {
      AuthService.logout();
      setIsAuthenticated(false);
      setUser(null);
      setError('Session expired. Please login again.');
    };

    window.addEventListener('docuid-unauthorized', handleUnauthorized);

    const auth = AuthService.getStoredAuth();
    if (auth) {
      setIsAuthenticated(true);
      setUser({
        phone: auth.phone,
        name: auth.user?.name,
        email: auth.user?.email,
      });
    }

    return () => {
      window.removeEventListener('docuid-unauthorized', handleUnauthorized);
    };
  }, []);

  return { isAuthenticated, isLoadingLogin, user, error, login, logout, setError };
}
